module.exports = __webpack_public_path__ + "img/KIDIWI-digital-white.svg";